import {CommonReducer, ReducerFromState} from "../../@types/reducers";
import {MoneyLineObject} from "../../@types/response";


export const getEventsMoneyLine = (state: ReducerFromState<CommonReducer>): MoneyLineObject => state.common.eventsMoneyLine;

